import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberRegistrationTypeForm from '../../../components/forms/MemberRegistrationTypeForm';
import { useCreateMemberRegistrationType } from '../../../hooks/useMemberRegistrationTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberRegistrationTypeDTO } from '../../../services/apiClient';

const MemberRegistrationTypeCreate: React.FC = () => {
  const createMutation = useCreateMemberRegistrationType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Registration Types', href: '/admin/memberregistrationtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberRegistrationTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberregistrationtypes');
    } catch (error) {
      console.error('Error creating MemberRegistrationType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberregistrationtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberRegistrationType.Edit'
    >
        <MemberRegistrationTypeForm
          initialValues={{} as MemberRegistrationTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberregistrationtypes')}
        />
    </AdminLayout>
  );
};

export default MemberRegistrationTypeCreate;